import { ControlStatusService } from './../shared/control-status.service';
import { Component, OnInit } from '@angular/core';
import { NgIf } from '@angular/common';

@Component({
    selector: 'popup-jasper',
    templateUrl: './popup-jasper.component.html',
    styleUrls: ['./popup-jasper.component.css'],
    standalone: true,
    imports: [NgIf]
})
export class PopupJasperComponent implements OnInit {

  constructor(public controlStatus:ControlStatusService) { }

  ngOnInit(): void {
  }

  fecharLoading() {
    this.controlStatus.erroRelatorio = false;
    this.controlStatus.carregandoRelatorios = false;
  }

}
